/**
 * Created by ren on 12/07/2017.
 */

import * as APIUtil from '../apiUtils';
import * as APICommon from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export const saveShiftType = ( app, params ) => {
  const { user = {}, data } = params;

  const shiftType = {
    doc_type      : DocType.SHIFT_TYPE,
    active        : APIUtil.toBoolean( data.active ),
    name          : APIUtil.toStringText( data.name ),
    short_name    : APIUtil.toStringText( data.short_name ),
    system_defined: APIUtil.toBoolean( data.system_defined ),
  };

  return APICommon.saveDoc( app, { source: data, doc: shiftType, user } );
};

export const deleteShiftType = ( app, params ) => APICommon.deleteDoc( app, { id: params.id, docType: DocType.SHIFT_TYPE } );

export const fetchShiftTypeById = ( app, params ) => {
  const { id } = params;
  const docType = DocType.SHIFT_TYPE;
  return APICommon.getDoc( app, { id, docType } );
};
